const filterDrawer = document.querySelector("[data-filter-drawer]");
const filterOverlay = document.querySelector("[data-filter-drawer-overlay]");

document.querySelectorAll("[data-filter-toggle]").forEach((el) => {
  el.addEventListener("click", () => {
    document.body.classList.toggle("overflow-hidden");

    if (filterDrawer) {
      filterDrawer.classList.toggle("translate-y-full");
    }
    if (filterOverlay) {
      filterOverlay.classList.toggle("opacity-50");
      filterOverlay.classList.toggle("invisible");
    }
  });
});
